export const DocumentBlockedNoticeTestIds = {
  DOCUMENT_BLOCKED_NOTICE: 'documentBlockedNotice.container',
};
